import LocationsModel from 'models/LocationsModel';

LocationStore.dispatchToken = MakeShiftEmployeeDispatcher.register(LocationStore.dispatchCallback);

LocationStore.getLocationById = function (locationId) {
  let loc = LocationStore.get(locationId);
  if (!Utils.isNotDefined(loc)) {
    loc = loc.present();
  }
  return loc;
};

LocationStore.onLocationHandler = function (data, response, options) {
  LocationStore.trigger('load:success', data, response, options.target);
};

LocationStore.onLocationError = function (error) {
  LocationStore.trigger('load:error');
};
